/** Construct only the known private assistant route; never trust payload URLs. */
export function getAssistantBriefingPath(
  data: Record<string, unknown> | null | undefined
): string | null {
  if (
    !data ||
    !["daily_attention", "weekly_changes"].includes(String(data.kind))
  )
    return null;
  const project = String(data.project_id ?? "");
  const conversation = data.conversation_id;
  if (
    !/^[1-9]\d*$/.test(project) ||
    !Number.isSafeInteger(Number(project)) ||
    typeof conversation !== "string" ||
    !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
      conversation
    )
  )
    return null;
  return `/projects/${project}/operations/intelligence/context/assistant?conversation=${conversation}`;
}
